import axios from 'axios'
import dayjs from 'dayjs'
import api from '@/api'


import {
    VUEX_WIP_INITIALIZE,
    
    VUEX_WIP_FETCH_JOBS,
    VUEX_WIP_FETCH_JOBS_SUCCESS,
    VUEX_WIP_SET_CANCEL_REQUEST,

    VUEX_WIP_INCREMENT_PAGINATION_PAGE,
    VUEX_WIP_RESET_PAGINATION_PAGE,

    VUEX_WIP_RESET
} from  '@/store/constants/work_in_progress'


const state = {
    jobs: [],
    initialized   : false,
    cancelRequest : null,
    pagination    : {
        // isJob    : true,
        page     : 1,
        status   : 9 + "," + 8,
        per_page : 23
    },
    refreshTimes : ['00:00', // 12AM
                    '04:00', // 4AM
                    '08:00', // 8AM
                    '18:00', // 6PM
                    '21:00'] // 9PM
}


const getters = {}


const actions = {
    [VUEX_WIP_INITIALIZE]: async ({state, dispatch, commit}) => {
        if(state.initialized) return 
        
        await commit(VUEX_WIP_FETCH_JOBS)
        dispatch(VUEX_WIP_FETCH_JOBS)
    },

    [VUEX_WIP_FETCH_JOBS]: ({ state, dispatch, commit }) => {
        if (state.cancelRequest) {
            state.cancelRequest.cancel()
        }

        commit(VUEX_WIP_SET_CANCEL_REQUEST, axios.CancelToken.source())

        api.get(`/jobs`, {
            params: {...state.pagination},
            cancelToken: state.cancelRequest.token
        }).then( response => {
            commit(VUEX_WIP_FETCH_JOBS_SUCCESS, response.data.data)
            
            // If incoming data.length is equal to number requested | increment page...
            if (response.data.data.length >= state.pagination.per_page) {
                commit(VUEX_WIP_INCREMENT_PAGINATION_PAGE)
            } else {
                commit(VUEX_WIP_RESET_PAGINATION_PAGE)
            }
            
            // Adjust timeout to match scroll speed 
            let t = dayjs().format('H:mm')

            if (state.refreshTimes.includes(t)) {
                dispatch(VUEX_WIP_RESET)
            } else {
                // dispatch(VUEX_WIP_FETCH_JOBS)
            }
        }).catch( error => {
            if(!axios.isCancel()) {
                // dispatch(VUEX_WIP_RESET)
            }
        })
    },

    [VUEX_WIP_RESET]: async ({ dispatch, commit }) => {
        await commit(VUEX_WIP_RESET)
        dispatch(VUEX_WIP_INITIALIZE)
    }
}


const mutations =  {
    [VUEX_WIP_FETCH_JOBS]: (state) => {
        state.initialized = true
    },

    [VUEX_WIP_FETCH_JOBS_SUCCESS]:(state, payload) => {
        state.jobs = state.jobs.concat(payload)
    },

    [VUEX_WIP_SET_CANCEL_REQUEST]:(state, payload) => {
        state.cancelRequest = payload
    },

    [VUEX_WIP_INCREMENT_PAGINATION_PAGE]:(state) => {
        ++state.pagination.page
    },

    [VUEX_WIP_RESET_PAGINATION_PAGE]:(state) => {
        state.pagination.page = 1
    },

    [VUEX_WIP_RESET]:(state) => {
        state.initialized = false
        state.jobs = []
        state.pagination.page = 1
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}